import { FullPageMessage } from '../FullPageMessage';

export const ErrorMessage = () => (
	<FullPageMessage
		state="error"
		message="Something went wrong"
		secondaryText="Please try again later"
		showGoHome
	/>
);
